<template>
<div class="quote-smt"
	:data-isparams="isParamsOk"
	:class="(relation === 'smd' || stay === 'smd')?'quote-box-wrap':'quote-nocheck'"
>
	<!-- pcb gerberview -->
	<pcb-upgerberfile v-if="stay === 'smd'" :pcbParams="params" @resolveGerberSuccess="resolveGerberSuccess" @resolveGerberFailed="resolveGerberFailed" @getfid="getfid"></pcb-upgerberfile>
	<!-- <quote-relation :title="LANG.stencil"  name="smd" @reset="handleReset"></quote-relation> -->
	<div v-if="relation === 'smd'" class="title-bar" @click="showSmd = !showSmd">
		<h2>Stencil Parameters</h2>
		<a class="show-more">
			<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="showSmd ? 'roate-arrow' : 'roate-arrow1'"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
		</a>
	</div>
	<template v-if="relation === 'smd' || stay === 'smd'">
		<div v-show="showSmd" class="quote-box-group" style="border: 0;">
			<!-- Border Type: -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.stencil_frame}}<i class="empty-icon"></i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.stencil_frame" :items="list.stencil_frame"></quote-check>
				</div>
			</div>
			<!-- Stencil Type: -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.stencil_type}}
					<i  @mouseover="alertHelp($event,'stencil_type_note')" @mouseleave="alertHelp($event,'stencil_type_note')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.stencil_type" :items="list.stencilTypeItem">
						<span slot="gt">
							<img class="vlm mg-l-md" src="//static.nextpcb.com/images/quote/stencilTip1.png" alt="">
						</span>
						<template v-slot:itemend="items">							
							<i v-if="items.item.index>0" @click.stop="(e)=>{e.preventDefault()}"
								@mouseover="sizeToggle"
								@mouseleave="sizeToggle"
								class="icon mg-l-xs trans-animate vlm fs-xs quote-help"
							>?</i>
						</template>
						<!-- <template slot="end">
							<span class="fc-main fs-sm vlm " @mouseover="sizeToggle" @mouseleave="sizeToggle">
								Case Display 
							</span>	
						</template>	 -->					
					</quote-check>
					
				</div>
			</div>
			<!-- Printing Method -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.printing_method}}
					<i  @mouseover="alertHelp($event,'printing_method_note')" @mouseleave="alertHelp($event,'printing_method_note')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.printing_type" :items="list.printing_type"></quote-check>
				</div>
			</div>
			<!-- Size(mm): -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.size_mm}}
					<i  @mouseover="alertHelp($event,'readhelp_size(mm)')" @mouseleave="alertHelp($event,'readhelp_size(mm)')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<src-select style="width: 300px;" v-model="params.stencil_size" :items="list.stencilSizeList"></src-select>
					<p  v-if="printsizeTipsShow" class="fc-main pd-t-xs fs-sm">{{LANG.suitable_for_manual_printing}}</p>
				</div>
			</div>
			<!-- Stencil Side -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.stencil_side}}
					<i @mouseover="alertHelp($event,'readhelp_stencil side')" @mouseleave="alertHelp($event,'readhelp_stencil side')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.stencil_side" :items="list.stencilSideItem"></quote-check>
					<p  v-if="params.stencil_side === 'Separate Top Bottom'" class="fc-main pd-t-xs fs-sm">{{LANG.smd_separate_top_bottom_tips}}</p>
				</div>				
				</div>
			<!-- Quantity -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.quantity}}<i class="empty-icon"></i>
					</span>
				</div>
				<div class="quote-box-items pd-t-sm">
					<!-- <np-input type="number" :replace="/[^0-9]/g"  width = "142px" class="vlm" v-model="params.stencil_num">
						<em slot="gt" class="icon pd-lg-sm  fs-sm quote-input-units">
							pcs
						</em>
					</np-input> -->
					<div class="number-input-box">
						<i class="f-bold fs-bs" @click="clickReduceNumber">—</i>
						<input v-model="params.stencil_num" type="number" class="input-box" disabled/>
						<i class="add-icon" @click="clickAddNumber">+</i>
						<span class="set-unit-box">pcs</span>
					</div>
				</div>
			</div>
			<!-- Thickness -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.thickness}}<i class="empty-icon"></i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.stencil_thickness" :items="list.stencilThicknessItem"></quote-check>
				</div>
			</div>
			<!--Existing Fiducials -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.existing_fiducials}}
					<i @mouseover="alertHelp($event,'readhelp_existing fiducials')" @mouseleave="alertHelp($event,'readhelp_existing fiducials')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.existing_fiducials" :items="list.stencilFiducialsItem"></quote-check>
				</div>
			</div>
			<!--Electropolishing -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.electropolishing}}
					<i @mouseover="alertHelp($event,'readhelp_electropolishing')" @mouseleave="alertHelp($event,'readhelp_electropolishing')" class="icon trans-animate vlm fs-xs quote-help">?</i>
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.elec_tropolishing" :items="list.electropolishingItem"></quote-check>
				</div>
			</div>
			<!--Engineering Requirements -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.engineering_requirements}}
					</span>
				</div>
				<div class="quote-box-items">
					<quote-check v-model="params.engineering_require" :items="list.engineeringRequireItem"></quote-check>
				</div>
			</div>

			<!-- Add PO No -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.add_po_no}}<i class="empty-icon"></i>
					</span>
				</div>
				<div class="quote-box-items">
					<np-input class="vlm" v-model="params.stencil_po_number" width="160px" :maxlength="25">
						<template slot="gt"></template>
					</np-input>
				</div>
			</div>
			
			<!-- Special Requests -->
			<div class="quote-box-line">
				<div class="quote-box-tags">
					<span class="t_text">
					{{LANG.special_requests}}<i class="empty-icon"></i>
					</span>
				</div>
				<div class="quote-box-items">
					<textarea id="smdNote" class="quote-note-textarea pd-lg-sm pd-tb-xs" :class="{'note-err':smdNoteErr}" :placeholder="LANG.smd_note_placeholder"  v-model="params.stencil_note" @blur="handleValidLen($event)"></textarea>
					<p v-show="smdNoteErr" class="fc-main pd-t-xs fs-sm"> {{LANG.note_len_tip}}</p>
				</div>
			</div>

		</div>
	</template>
</div>
</template>

<script>
import quoteRelation from '@/components/quote/quote_relation.vue'
import quotecheck from '@/_module/quotecheck/index.vue'
import input from '@/_module/input/index.vue'
import srcselect from '@/_module/srcselect/index.vue'
import pubmixin from '@/mixins/quote/public_mixin.js'
import pcbUpgerberfile from '@/components/quote/pcb_upgerberfile.vue'
export default {
	name:"quote_smd",
	mixins:[pubmixin('smd')],
	data(){
		return {
			params:{
				stencil_type:'',
				stencil_size:'',
				stencil_side:'',
				stencil_num: '',
				stencil_thickness:'',
				existing_fiducials:'',
				elec_tropolishing:'',
				engineering_require: 1,
				stencil_frame: '',
				printing_type: '',
				stencil_note: '',
				stencil_po_number:'',
				smd_part_no:''
			},
			list:{
				//钢网边框类型
				stencil_frame:[{real:'Framework',word:"Framework",keys:"framework"},
					{real:'Non-framework',word:"Non-framework",keys:"non-framework"}],
				//印刷方式
				printing_type :[
					{real:1,word:"Semi-automatic Printing",keys:"semi-automatic_printing"},
					{real:2,word:"Fully Automatic Printing",keys:"fully_automatic_printing"},
					{real:3,word:"Manual Printing",keys:"manual_printing"}
				],
				stencilSizeList: [],
				stencilTypeItem: [
					{real:'Stencil for Solder Paste',word:"Stencil for Solder Paste",keys:"stencil_for_solder_paste"},
					{real:'Stencil for Adhesives',word:"Stencil for Adhesives",keys:"stencil_for_adhesives"},
					{real:'Step Down Stencil',word:"Step Down Stencil",keys:"step_down_stencil"}
				],
				stencilSizeItem: [
					{real:'300x400mm',word:"300x400mm(Valid area 120x220mm)"},
					{real:'370x470mm',word:"370x470mm(Valid area 190x290mm)"},
					{real:'420x520mm',word:"420x520mm(Valid area 240x340mm)"},
					{real:'450x550mm',word:"450x550mm(Valid area 270x370mm)"},
					{real:'584x584mm',word:"584x584mm(Valid area 380x380mm)"},
					{real:'550x650mm',word:"550x650mm(Valid area 350x450mm)"},
					{real:'736x736mm',word:"736x736mm(Valid area 500x500mm)"},
					{real:'400x600mm',word:"400x600mm(Valid area 220x400mm)"},
					{real:'400x800mm',word:"400x800mm(Valid area 220x600mm)"},
					{real:'400x1000mm',word:"400x1000mm(Valid area 220x760mm)"},
					{real:'400x1200mm',word:"400x1200mm(Valid area 220x1000mm)"},
					{real:'400x1400mm',word:"400x1400mm(Valid area 220x1200mm)"},
					{real:'500x700mm',word:"500x700mm(Valid area 320x500mm)"},
					{real:'500x1200mm',word:"500x1200mm(Valid area 320x600mm)"},
					{real:'500x800mm',word:"500x800mm(Valid area 320x1300mm)"}
				],
				stencilSizePast:[
					{real:'300x400mm',word:"300x400mm(Valid area 140x240mm)"},
					{real:'370x470mm',word:"370x470mm(Valid area 190x290mm)"},
					{real:'420x520mm',word:"420x520mm(Valid area 240x340mm)"},
					{real:'450x550mm',word:"450x550mm(Valid area 270x370mm)"},
					{real:'584x584mm',word:"584x584mm(Valid area 380x380mm)"},
					{real:'550x650mm',word:"550x650mm(Valid area 350x450mm)"},
					{real:'736x736mm',word:"736x736mm(Valid area 500x500mm)"}
				],
				stencilSizeItem2: [
					{real:'550x550mm',word:"550x550mm(Valid area 550x550mm)"},
					{real:'280x380mm',word:"280x380mm(Valid area 190x290mm)"},
					{real:'100x150mm',word:"100x150mm(Valid area 100x150mm)"}
				],
				stencilSideItem:[{real:'Top',word:"Top",keys:"top"},{real:'Bottom',word:"Bottom",keys:"bottom"},{real:'Combine Top Bottom',word:"Top & Bottom",keys:"top & bottom"},{real:'Separate Top Bottom',word:"Top & Bottom ( Different Solder Paste ) ",keys:"top & bottom ( different solder paste )"}],
				stencilThicknessItem:[{real: '0.10',word:'0.10mm'},{real: '0.12',word:'0.12mm'},{real: '0.15',word:'0.15mm'},{real: '0.2',word:'0.2mm'}],
				stencilFiducialsItem: [{real: 'None',word:'None',keys:"none"},{real: 'Half lasered',word:'Half lasered',keys:"half lasered"},{real: 'Lasered through',word:'Lasered through',keys:"lasered through"}],
				electropolishingItem: [{real:0,word:"Grinding and Polishing",keys:"grinding_and_polishing"},{real:1,word:"Electropolishing",keys:"electropolishing"}],
				engineeringRequireItem: [{real:1,word:"nextpcb_specification",keys:"nextpcb_specification"},{real:2,word:"confirm_by_customer",keys:"confirm_by_customer"}],
			},
			smdNoteErr: false,
			showSmd: true
		}
	},
	mounted(){
		this.list.stencilTypeList = this.list.stencilSizeItem;
		setTimeout(()=>{
			this.seturlDefault();
			this.countPrinting_type();
			console.log('smd ***',this.isChangeParams)
		})	
	},
	computed:{
		printsizeTipsShow(){
			let stencil_frame = this.params.stencil_frame;
			let stencil_size = this.params.stencil_size;
			if(stencil_frame !== 'Framework') {
				return true;
			}
			return stencil_frame === 'Framework' && (stencil_size === '300x400mm' || stencil_size === '370x470mm' );
		},
		isParamsOk(){
			/*
			滿足以下項既可
			1，數量 stencil_num
			*/
			if(this.params.stencil_num){
				this.$store.commit("setQuoteStatus",{key:'smd',value:true})
				return true;
			}
			this.$store.commit("setQuoteStatus",{key:'smd',value:false});
			return false;
		},
		isChangeParams() {
			return this.$store.state.isChangeParams
		},
		changeParams() {
			return this.$store.state.changeParams
		},
		kicadGerber() {
			return this.$store.state.quote.gerber
		},
		smd_params() {
			return this.$store.state.quote.smd_params
		},
		relation() {
			return this.$store.state.quote.relation
		}
	},
	methods:{	
		// 点击减少钢网数量
		clickReduceNumber() {
			if(this.params.stencil_side == 'Separate Top Bottom') {
				console.log(265, this.params.stencil_num)
				if(this.params.stencil_num == 2) return this.$alert.msg(this.LANG.smd_number2_10)
				this.params.stencil_num = Number(this.params.stencil_num) - 2
			} else {
				if(this.params.stencil_num == 1) return this.$alert.msg(this.LANG.smd_number1_5)
				this.params.stencil_num = Number(this.params.stencil_num) - 1
			}
			this.countCalc();
		},
		// 点击增加钢网数量
		clickAddNumber() {
			if(this.params.stencil_side == 'Separate Top Bottom') {
				console.log(265, this.params.stencil_num)
				if(this.params.stencil_num == 10) return this.$alert.msg(this.LANG.smd_number2_10)
				this.params.stencil_num = Number(this.params.stencil_num) + 2
			} else {
				if(this.params.stencil_num == 5) return this.$alert.msg(this.LANG.smd_number1_5)
				this.params.stencil_num = Number(this.params.stencil_num) + 1
			}
			this.countCalc();
		},
		resolveGerberSuccess(res){
			this.params.isgerber = 0;
			// 回填pcb的尺寸blength，bwidth及校验红框
			this.$bus.$emit('analysisFileSuccessEvent', res)
			console.log(291, res, this.params)
		},
		resolveGerberFailed() {
			this.$bus.$emit('analysisFileFailEvent')
		},
		getfid(fid, pcbParsingFile){
			this.params.fid = fid;
			this.params.pcbParsingFile = pcbParsingFile
			this.$store.commit("setQuoteParams",{value:fid,key:"aside_param.gerber_file_id"});	
			this.$store.commit("setQuoteParams",{value:pcbParsingFile ? pcbParsingFile.url : '',key:"aside_param.gerber_file"});			
		},
		handleReset(){
			window.location.reload();			
		},	
		sizeToggle(e){
			//
			this.$alert.dialog({
				//position:"top",
				content:`<div style="width:334px;">
							<span class="vlm" style="margin-right:12px;">
								<img src='//static.nextpcb.com/images/img30/quote/smd-show1.jpg'/>
								<p class="">Stencil for Adhesives</p>
							</span>
							<span class="vlm">
								<img src='//static.nextpcb.com/images/img30/quote/smd-show2.jpg'/>
								<p class="">Step Down Stencil</p>
							</span>
						</div>
						`,					
				show:true
			},e)
		},
		seturlDefault(){
			let query = this.$route.query;
			for(let k in query){				
				if(k.toLowerCase().indexOf("type")>=0){
					this.params.stencil_frame = query[k];
				}
				if(k.toLowerCase().indexOf("size")>=0){
					this.params.stencil_size = query[k];
				}
				if(k.toLowerCase().indexOf("number")>=0){
					this.params.stencil_num = query[k];
				}				
			}

			// kicad文件确认后回来
			if (query.aid && query.isDfm) {
				const analyseId=query.aid
        const smdData=JSON.parse(sessionStorage.getItem('smd'+analyseId)) || {}

				for( let i in smdData) {
					this.params[i] = smdData[i]
				}
			}
		},
		countCalc(){			
			if(this.isParamsOk && this.isrelationParamsOk){
				this.$alert.loading(true);
				this.$store.commit("setQuoteLoading",true);
				let _this = this;
				this.$tools.debounce(()=>{
					this.$alert.loading(false);
					let promise = this.$store.dispatch("calcQuoteValuation");
					if(promise){
						promise.then((res)=>{
							if(!res || res.code != 200){
								_this.$alert.msg(res.msg);
							}
						})
					}
				},"countCalc",1050)();
			}
		},
		countStencil_frame(){
			let stencil_frame = this.params.stencil_frame;
			let stencil_type = this.params.stencil_type;
			if(stencil_frame === "Non-framework"){
				this.list.stencilSizeList = this.list.stencilSizeItem2;
				const hasSelected = this.list.stencilSizeList.some(item => item.real == this.params.stencil_size)
				if (!this.isChangeParams && (!this.params.stencil_size || !hasSelected)) {
					this.params.stencil_size =  this.list.stencilSizeItem2[1].real;
				}
				this.params.printing_type = 3;
				//禁用printing_type前面两项
				this.$set(this.list.printing_type[0],"disable",true)
				this.$set(this.list.printing_type[1],"disable",true)
				this.$set(this.list.stencilTypeItem[2],"disable",true)
				if(this.params.stencil_type === "Step Down Stencil"){
					this.params.stencil_type = "Stencil for Solder Paste"
				}
			}else{
				this.list.stencilSizeList = this.list.stencilSizeItem;
				const hasSelected = this.list.stencilSizeList.some(item => item.real == this.params.stencil_size)
				if(!this.$tools.inArray(this.params.stencil_size,this.list.stencilSizeItem,"real")){
					try{
						if (!this.isChangeParams && (!this.params.stencil_size || !hasSelected)) {
							this.params.stencil_size =  this.list.stencilSizeItem[1].real;
						}
					}catch(e){
						console.log(e)
					}					
				}
				if(stencil_type === "Step Down Stencil"){
					this.list.stencilSizeList = this.list.stencilSizePast;
					if(!this.$tools.inArray(this.params.stencil_size,this.list.stencilSizePast,"real")){
						if (!this.isChangeParams && !this.params.stencil_size) {
							this.params.stencil_size =  this.list.stencilSizePast[0].real;
						}
					}
				}
				if(this.params.stencil_size !== "300x400mm" && this.params.stencil_size !== "370x470mm") {
					//解除禁用printing_type前面两项
					this.$set(this.list.printing_type[0],"disable",false)
					this.$set(this.list.printing_type[1],"disable",false)
				}
				this.$set(this.list.stencilTypeItem[2],"disable",false)
			}
		},
		countPrinting_type(){
			let stencil_frame = this.params.stencil_frame;
			let stencil_size = this.params.stencil_size;
			
			if(stencil_frame === "Framework"){
				//stencil_size
				if(stencil_size === "300x400mm" || stencil_size === "370x470mm"){
					this.$set(this.list.printing_type[0],"disable",true);
					this.$set(this.list.printing_type[1],"disable",true);
					if(this.params.printing_type == 2){
						this.$set(this.params,"printing_type",1)
					}
				}else{
					this.$set(this.list.printing_type[0],"disable",false);
					this.$set(this.list.printing_type[1],"disable",false);
				}				
			}
		},
		countStencil_size(){
			let printing_type = this.params.printing_type;
			let stencil_frame = this.params.stencil_frame;
				if(stencil_frame === "Framework"){
					if(printing_type == 1 || printing_type == 2){
						if(this.$tools.inArray("370x470mm",this.list.stencilSizeList,"real")){							
							this.$tools.inArray("370x470mm",this.list.stencilSizeList,"real","del")
						}
						if(this.$tools.inArray("300x400mm",this.list.stencilSizeList,"real")){
							this.$tools.inArray("300x400mm",this.list.stencilSizeList,"real","del")
						}						
					}else{		
						if(!this.$tools.inArray("370x470mm",this.list.stencilSizeList,"real")){
							this.list.stencilSizeList.unshift({real:'370x470mm',word:"370x470mm(Valid area 190x290mm)"});
						}
						if(!this.$tools.inArray("300x400mm",this.list.stencilSizeList,"real")){
							this.list.stencilSizeList.unshift({real:'300x400mm',word:"300x400mm(Valid area 140x240mm)"});
						}						
					}				
				}				
		},
		handleValidLen(e){
			const value = e.target.value
			if (value && (value.length < 5 || value.length > 1000)) {
				this.$alert.msg(this.LANG.note_len_tip)
				this.smdNoteErr = true
			}
			else{
				this.smdNoteErr = false
			}
		},
		initChangeParams(info) {
			for(let k in this.params) {
				this.params[k] = info[k]
				// console.log(k, info[k])
			}

			console.log('smd initChangeParams *** ', this.params)
		}
	},
	watch:{
		changeParams: {
			handler(v) {
				if(this.isChangeParams) {
					this.initChangeParams(v)
				}
			},
			deep: true
		},
		"params.stencil_frame": function(v){
			this.countStencil_frame();
			this.countPrinting_type();
			this.countStencil_size();
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_frame"});
			//執行計價方法
			this.countCalc();
		},
		"params.printing_type": function(v){
			this.countStencil_size();
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.printing_type"});
			//printing_type
			this.countCalc();
		},
		"params.stencil_type": function(v){
			this.countStencil_frame();
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_type"});
			//執行計價方法
			this.countCalc();
		},
		"params.stencil_size": function(v){		
			this.countPrinting_type();
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_size"});
			//執行計價方法
			this.countCalc();
		},
		"params.stencil_side": function(v,ov){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_side"});
			if(v === "Separate Top Bottom" && this.params.stencil_num%2 !== 0){
				this.params.stencil_num = 2;
			}else{
				if(v !== "Separate Top Bottom" && ov === "Separate Top Bottom" && this.params.stencil_num > 5){
					this.params.stencil_num = 1;
				}
			}
			//執行計價方法
			this.countCalc();			
		},
		"params.stencil_num": function(v){
			// this.$tools.debounce(()=>{
			// if(v>6){
			// 	this.params.stencil_num = 6;
			// 		return this.$alert.msg("The max number is limited to 5")
			// }
			// 	if(this.params.stencil_side === "Separate Top Bottom" && v%2 !== 0){
			// 		return this.params.stencil_num = "";
			// 	}
			// 	//執行計價方法
			// 	this.countCalc();					
			// },"inputQuantity",1050)();			
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_num"});
			
		},
		"params.stencil_thickness": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_thickness"});
			//執行計價方法
			this.countCalc();
		},
		"params.existing_fiducials": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.existing_fiducials"});
			//執行計價方法
			this.countCalc();
		},
		"params.elec_tropolishing": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.elec_tropolishing"});
			//執行計價方法
			this.countCalc();
		},
		"params.engineering_require": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.engineering_require"});
			//執行計價方法
			this.countCalc();
		},
		"params.stencil_po_number": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_po_number"});			
		},
		"params.stencil_note": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"smd_params.stencil_note"});
		},
		smd_params: {
			handler(v) {
				if(['smd', 'pcb', 'pcb_high'].includes(this.relation) && this.kicadGerber.analyseId && this.kicadGerber.isKicad && !this.$route.query?.aid) {
					window.sessionStorage.setItem('smd' + this.kicadGerber.analyseId, JSON.stringify(v))
				}
			},
			deep: true
		},
		kicadGerber: {
      handler(v) {
        if(['smd', 'pcb', 'pcb_high'].includes(this.relation) && v.analyseId && v.isKicad && !this.$route.query?.aid) {
          window.sessionStorage.setItem.setItem('smd' + v.analyseId , JSON.stringify(this.smd_params))
        }
      },
      deep: true
    }
	},
	components: {
		'quote-check':quotecheck,
		'np-input':input,
		"quote-relation":quoteRelation,
		"src-select":srcselect,
		'pcb-upgerberfile':pcbUpgerberfile
	}
}
</script>

<style lang="scss" scoped>
.number-input-box {
  display: flex;
  .input-box {
    width: 110px;
    height: 28px;
    border: 1px solid #b8802c;
    padding: 0 10px;
    text-align: center;
  }
  i {
    display: inline-block;
    width: 36px;
    height: 30px;
    background: #b8802c;
    color: #fff;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
  .add-icon {
    font-size: 28px;
    line-height: 26px;
  }
  .set-unit-box {
    width: 34px;
    height: 28px;
    border: 1px solid #cccccc;
    display: inline-block;
    text-align: center;
    line-height: 28px;
    margin-left: 10px;
  }
}

.title-bar{
	width: 100%;
	height: 36px;
	background: #f8f8f8;
	border-radius: 4px;
	box-sizing: border-box;
	padding: 0 10px 0 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
	// margin-bottom: 10px;

	h2 {
		font-size: 16px;
		font-weight: 700;
	}

	.show-more{
		padding: 10px;
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #999;
		&:hover{
			.icon-arrow {
				.main {
					fill: #7a7a7a;
				}
			}
		
		}

		.icon-arrow {
			.bg {
				fill: none;
			}

			.main {
				fill: #c7c6c6;
			}
		}
	}
}

.roate-arrow{
		transform: rotate(180deg);
		transition: all 0.3s;
	}
	.roate-arrow1{
		transform: rotate(0deg);
		transition: all 0.3s;
	}
</style>